<template>
    <edit></edit>
</template>
<script>
    import edit from './abstract_consultation_edit.vue'

    export default {
        name: 'abstract_consultation_add',

        components: {
            edit
        }
    }
</script>
